import { getAllUsersRequest } from "./request";
import { useQuery } from "react-query";


export const useFetchUserAll = () => {
    return useQuery(["UseUserAll"], getAllUsersRequest);
};